// import React, { useState, useRef, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMessage,
//   faXmark,
//   faRotate,
//   faPaperPlane,
//   faUser,
//   faChevronRight,
// } from "@fortawesome/free-solid-svg-icons";
// import * as signalR from "@microsoft/signalr";
// import "./ChatWidget.css";
// import AnlookOwl from "../../src/Images/aivideo.gif";
// import AnlookBanner from "../../src/Images/cardicon3.svg";
// import { basicauth } from "../Utils/Credentials";

// const SIGNALR_URL = "https://blogapi.bumppy.com/ws/support-chat";

// const ChatWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [view, setView] = useState("list");
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [UserClient, setUserClient] = useState("");
//   const [connection, setConnection] = useState(null);
//   const messagesEndRef = useRef(null);

//   const { username, password } = basicauth;
//   const base64Credentials = btoa(`${username}:${password}`);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   useEffect(scrollToBottom, [messages]);

//   const connectSocket = async (mobile) => {
//     if (!mobile || connection) return;

//     const conn = new signalR.HubConnectionBuilder()
//       .withUrl(SIGNALR_URL)
//       .withAutomaticReconnect()
//       .build();

//     conn.on("LoadChatHistory", (data) => {
//       //setMessages(data || []);
//     });

//     conn.on("ReceiveChat", (data) => {
//       setMessages((prev) => [
//         ...prev,
//         {
//           id: Date.now(),
//           message: data.message,
//           type: data.type,
//           datetime: data.datetime,
//         },
//       ]);
//     });

//     await conn.start();
//     await conn.invoke("JoinChat", mobile);

//     setConnection(conn);
//   };

//   useEffect(() => {
//     return () => {
//       if (connection) connection.stop();
//     };
//   }, [connection]);

//   /* ---------------- SEND MESSAGE ---------------- */
//   const SendText = async () => {
//     if (!newMessage.trim()) return;

//     try {
//       await fetch(
//         `https://api.seobix.com/api/Support/sendSupportChatUser`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Basic ${base64Credentials}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             mobile: UserClient,
//             message: newMessage,
//           }),
//         }
//       );

//       setMessages((prev) => [
//         ...prev,
//         {
//           id: Date.now(),
//           message: newMessage,
//           type: "SENT",
//           datetime: new Date().toISOString(),
//         },
//       ]);

//       setNewMessage("");
//     } catch (err) {
//       console.error("Send failed", err);
//     }
//   };

//   /* ---------------- FORM HANDLERS ---------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     SendText();
//   };

//   const handleNewChat = async (e) => {
//     e.preventDefault();
//     const formData = new FormData(e.target);
//     const mobile = formData.get("phone");

//     setUserClient(mobile);
//     setView("chatHistory");

//     await fetch(`https://api.seobix.com/api/Support/submitChatUserDetails`, {
//       method: "POST",
//       headers: {
//         Authorization: `Basic ${base64Credentials}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         userName: formData.get("name"),
//         userEmail: formData.get("email"),
//         userMobile: mobile,
//       }),
//     });

//     connectSocket(mobile);
//   };

//   const [verificationMethod, setVerificationMethod] = useState("email");

//   const handleVerification = (e) => {
//     e.preventDefault();
//     const mobile = new FormData(e.target).get("verification");
//     setUserClient(mobile);
//     setView("chatHistory");
//     connectSocket(mobile);
//   };

//   const [showOwl, setShowOwl] = useState(true);
//   useEffect(() => {
//     const i = setInterval(() => setShowOwl((p) => !p), 700);
//     return () => clearInterval(i);
//   }, []);

//   /* ---------------- UI (UNCHANGED) ---------------- */
//   return (
//     <div className="custom_chat_container">
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="custom_chat_button"
//         style={{ display: isOpen ? "none" : "flex" }}
//       >
//         <img src={AnlookOwl} alt="Owl" className="chatbot_owl_image" />
//       </button>

//       {isOpen && (
//         <div className="custom_chat_widget">
//           <div className="custom_chat_header">
//             <div className="custom_header_text">
//               <h2>Hello <div className="wave">👋🏻</div></h2>
//               <h2 className="custom_header_title">Welcome to SeoBix</h2>
//             </div>
//             <div className="custom_header_buttons">
//               <button onClick={() => setIsOpen(false)} className="custom_header_button">
//                 <FontAwesomeIcon icon={faXmark} />
//               </button>
//             </div>
//           </div>

//           <div className="custom_chat_content">
//             {view === "list" && (
//               <>
//                 <div className="custom_chat_card_banner">
//                   <img src={AnlookBanner} alt="" />
//                 </div>

//                 <div onClick={() => setView("verifyUser")} className="custom_chat_card">
//                   <FontAwesomeIcon icon={faUser} /> Continue Conversation
//                 </div>

//                 <div onClick={() => setView("newChat")} className="custom_chat_card">
//                   <FontAwesomeIcon icon={faMessage} /> Start New Chat
//                 </div>
//               </>
//             )}

//             {view === "verifyUser" && (
//               <form onSubmit={handleVerification} className="custom_chat_form">
//                 <input name="verification" required className="custom_form_input" />
//                 <button type="submit" className="custom_submit_button">Continue Chat</button>
//               </form>
//             )}

//             {view === "newChat" && (
//               <form onSubmit={handleNewChat} className="custom_chat_form">
//                 <input name="name" required className="custom_form_input" />
//                 <input name="email" required className="custom_form_input" />
//                 <input name="phone" required className="custom_form_input" />
//                 <button type="submit" className="custom_submit_button">Start Chat</button>
//               </form>
//             )}

//             {view === "chatHistory" && (
//               <div className="custom_messages_container">
//                 {messages.map((m) => (
//                   <div
//                     key={m.id}
//                     className={`custom_message ${
//                       m.type === "SENT"
//                         ? "custom_message_user"
//                         : "custom_message_bot"
//                     }`}
//                   >
//                     <p>{m.message}</p>
//                   </div>
//                 ))}
//                 <div ref={messagesEndRef} />
//               </div>
//             )}
//           </div>

//           {view === "chatHistory" && (
//             <form onSubmit={handleSubmit} className="custom_chat_input_container">
//               <input
//                 value={newMessage}
//                 onChange={(e) => setNewMessage(e.target.value)}
//                 className="custom_chat_input"
//                 placeholder="Type your message..."
//               />
//               <button type="submit" className="custom_send_button">
//                 <FontAwesomeIcon icon={faPaperPlane} />
//               </button>
//             </form>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ChatWidget;

// import React, { useState, useRef, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMessage,
//   faXmark,
//   faRotate,
//   faPaperPlane,
//   faUser,
//   faChevronRight,
// } from "@fortawesome/free-solid-svg-icons";
// import * as signalR from "@microsoft/signalr";
// import "./ChatWidget.css";
// import AnlookOwl from "../../src/Images/aivideo.gif";
// import AnlookBanner from "../Images/logo.svg";
// import { basicauth } from "../Utils/Credentials";
// import { Card } from "react-bootstrap";

// const SIGNALR_URL = "https://blogapi.bumppy.com/ws/support-chat";

// const ChatWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [view, setView] = useState("list");
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [UserClient, setUserClient] = useState("");
//   const [connection, setConnection] = useState(null);
//   const [verificationMethod, setVerificationMethod] = useState("email");
//   const messagesEndRef = useRef(null);

//   const { username, password } = basicauth;
//   const base64Credentials = btoa(`${username}:${password}`);

//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const connectSocket = async (mobile) => {
//     if (!mobile || connection) return;

//     const conn = new signalR.HubConnectionBuilder()
//       .withUrl(SIGNALR_URL)
//       .withAutomaticReconnect()
//       .build();

//     conn.on("ReceiveChat", (data) => {
//       setMessages((prev) => [
//         ...prev,
//         {
//           id: Date.now(),
//           message: data.message,
//           type: data.type,
//           datetime: data.datetime,
//         },
//       ]);
//     });

//     await conn.start();
//     await conn.invoke("JoinChat", mobile);
//     setConnection(conn);
//   };

//   useEffect(() => {
//     return () => {
//       if (connection) connection.stop();
//     };
//   }, [connection]);

//   /* ---------------- SEND MESSAGE ---------------- */
//   const SendText = async () => {
//     if (!newMessage.trim()) return;

//     await fetch(`https://api.seobix.com/api/Support/sendSupportChatUser`, {
//       method: "POST",
//       headers: {
//         Authorization: `Basic ${base64Credentials}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         mobile: UserClient,
//         message: newMessage,
//       }),
//     });

//     setMessages((prev) => [
//       ...prev,
//       {
//         id: Date.now(),
//         message: newMessage,
//         type: "SENT",
//         datetime: new Date().toISOString(),
//       },
//     ]);

//     setNewMessage("");
//   };

//   /* ---------------- FORMS ---------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     SendText();
//   };

//   const handleNewChat = async (e) => {
//     e.preventDefault();
//     const formData = new FormData(e.target);
//     const mobile = formData.get("phone");

//     setUserClient(mobile);
//     setView("chatHistory");

//     await fetch(`https://api.seobix.com/api/Support/submitChatUserDetails`, {
//       method: "POST",
//       headers: {
//         Authorization: `Basic ${base64Credentials}`,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         userName: formData.get("name"),
//         userEmail: formData.get("email"),
//         userMobile: mobile,
//       }),
//     });

//     connectSocket(mobile);
//   };

//   const handleVerification = (e) => {
//     e.preventDefault();
//     const mobile = new FormData(e.target).get("verification");
//     setUserClient(mobile);
//     setView("chatHistory");
//     connectSocket(mobile);
//   };
//   const buttonStyle = {
//     padding: "10px 20px",
//     margin: "5px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//     backgroundColor: "#f5f5f5",
//     color: "#333",
//     cursor: "pointer",
//     transition: "all 0.3s ease",
//   };

//   return (
//     <div className="chat-wrapper">
//       {!isOpen && (
//         <button className="chat-fab" onClick={() => setIsOpen(true)}>
//           <img src={AnlookOwl} alt="chat" />
//         </button>
//       )}

//       {isOpen && (
//         <div className="chat-box">
//           {/* HEADER */}
//           <div className="chat-header">
//             <div>
//               <h1>
//                 Hello <span>👋</span>
//               </h1>
//               <h2>Welcome to SeoBix</h2>
//               <p>Need help with Seobix ?</p>
//             </div>
//             <div className="chat-header-actions">
//               {/* {view === "chatHistory" && (
//                 <FontAwesomeIcon
//                   icon={faRotate}
//                   onClick={() => setMessages([])}
//                 />
//               )} */}
//               <FontAwesomeIcon
//                 icon={faXmark}
//                 onClick={() => setIsOpen(false)}
//               />
//             </div>
//           </div>

//           {/* BODY */}
//           <div className="chat-body">
//             {view === "list" && (
//               <>
//                 <Card
//                   className="pt-3 pb-3 mb-3"
//                   style={{
//                     border: "none",
//                     borderRadius: "1rem",
//                     boxShadow: "0 6px 14px rgba(0,0,0,.08)",
//                   }}
//                 >
//                   <div className="d-flex justify-content-center ">
//                     <img
//                       src={AnlookBanner}
//                       alt="support"
//                       style={{ width: "50%" }}
//                     />
//                   </div>
//                 </Card>

//                 <div
//                   className="chat-card"
//                   onClick={() => setView("verifyUser")}
//                 >
//                   <div className="icon user" />
//                   <div>
//                     <h4>Continue Conversation</h4>
//                     <span>View your chat history</span>
//                   </div>
//                   <FontAwesomeIcon icon={faChevronRight} />
//                 </div>

//                 <div className="chat-card" onClick={() => setView("newChat")}>
//                   <div className="icon chat" />
//                   <div>
//                     <h4>Start New Chat</h4>
//                     <span>Get help from our team</span>
//                   </div>
//                   <FontAwesomeIcon icon={faChevronRight} />
//                 </div>

//                 <div className="chat-footer-text">— Welcome to Bix Support</div>
//               </>
//             )}

//             {view === "verifyUser" && (
//               <form onSubmit={handleVerification} className="chat-form">
//                 <div
//                   className="pill-switch"
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   <button
//                     type="button"
//                     style={{
//                       flex: 1,
//                       padding: "10px 0",
//                       borderRadius: "5px",
//                       border:
//                         verificationMethod === "email"
//                           ? "1px solid #4caf50"
//                           : "1px solid #ccc",
//                       backgroundColor:
//                         verificationMethod === "email" ? "#4caf50" : "#f5f5f5",
//                       color: verificationMethod === "email" ? "#fff" : "#333",
//                       cursor: "pointer",
//                       transition: "all 0.3s ease",
//                     }}
//                     onClick={() => setVerificationMethod("email")}
//                   >
//                     Email
//                   </button>

//                   <button
//                     type="button"
//                     style={{
//                       flex: 1,
//                       padding: "10px 0",
//                       borderRadius: "5px",
//                       border:
//                         verificationMethod === "mobile"
//                           ? "1px solid #4caf50"
//                           : "1px solid #ccc",
//                       backgroundColor:
//                         verificationMethod === "mobile" ? "#4caf50" : "#f5f5f5",
//                       color: verificationMethod === "mobile" ? "#fff" : "#333",
//                       cursor: "pointer",
//                       transition: "all 0.3s ease",
//                     }}
//                     onClick={() => setVerificationMethod("mobile")}
//                   >
//                     Mobile
//                   </button>
//                 </div>

//                 <label>
//                   Enter your{" "}
//                   {verificationMethod === "email" ? "Email" : "Mobile Number"}
//                 </label>

//                 <input
//                   name="verification"
//                   required
//                   placeholder={
//                     verificationMethod === "email"
//                       ? "your@email.com"
//                       : "1234567890"
//                   }
//                 />

//                 <button className="primary-btn">Continue Chat</button>
//                 <button
//                   type="button"
//                   className="secondary-btn"
//                   onClick={() => setView("list")}
//                 >
//                   Back to Menu
//                 </button>
//               </form>
//             )}

//             {view === "newChat" && (
//               <form onSubmit={handleNewChat} className="chat-form">
//                 <label>Name</label>
//                 <input name="name" required placeholder="Jhonny Bravo" />

//                 <label>Email</label>
//                 <input name="email" required placeholder="email@example.com" />

//                 <label>Phone</label>
//                 <input name="phone" required placeholder="911xxxxxx" />

//                 <button className="primary-btn">Start Chat</button>
//                 <button
//                   type="button"
//                   className="secondary-btn"
//                   onClick={() => setView("list")}
//                 >
//                   Back to Menu
//                 </button>
//               </form>
//             )}

//             {view === "chatHistory" && (
//               <div className="messages">
//                 {messages.map((m) => (
//                   <div
//                     key={m.id}
//                     className={`bubble ${
//                       m.type === "SENT" ? "sent" : "received"
//                     }`}
//                     style={{ position: "relative" }}
//                   >
//                     <div>{m.message}</div>
//                     <div
//                       style={{
//                         fontSize: "10px",
//                         color: "#888",
//                         marginTop: "4px",
//                         textAlign: m.type === "SENT" ? "right" : "left",
//                       }}
//                     >
//                       {m.datetime} {/* display datetime from websocket */}
//                     </div>
//                   </div>
//                 ))}
//                 <div ref={messagesEndRef} />
//               </div>
//             )}
//           </div>

//           {/* INPUT */}
//           {view === "chatHistory" && (
//             <form onSubmit={handleSubmit} className="chat-input">
//               <input
//                 value={newMessage}
//                 onChange={(e) => setNewMessage(e.target.value)}
//                 placeholder="Type your message..."
//               />
//               <button>
//                 <FontAwesomeIcon icon={faPaperPlane} />
//               </button>
//             </form>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ChatWidget;

import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
  faXmark,
  faRotate,
  faPaperPlane,
  faUser,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import * as signalR from "@microsoft/signalr";
import "./ChatWidget.css";
import AnlookOwl from "../../src/Images/aivideo.gif";
import AnlookBanner from "../Images/logo.svg";
import { basicauth } from "../Utils/Credentials";
import { Card } from "react-bootstrap";

// const SIGNALR_URL = "https://blogapi.bumppy.com/ws/support-chat";
const WS_URL = "wss://blogapi.bumppy.com/ws/admin-chat";

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("list");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [UserClient, setUserClient] = useState("");
  const [verificationMethod, setVerificationMethod] = useState("email");

  const socketRef = useRef(null);
  const messagesEndRef = useRef(null);

  const { username, password } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const connectWebSocket = () => {
    if (socketRef.current) return;

    const socket = new WebSocket(WS_URL);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log("🟢 WebSocket Connected");
    };

    socket.onmessage = (event) => {
      console.log("📩 WS MESSAGE:", event.data);

      const msg = JSON.parse(event.data);

      if (msg.type === "NEW_CHAT") {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now(),
            message: msg.data.lastMessage,
            type: msg.data.type === "SENT" ? "SENT" : "RECEIVED",
            datetime: msg.data.time,
          },
        ]);
      }
    };

    socket.onerror = (e) => {
      console.error("❌ WebSocket Error", e);
    };

    socket.onclose = () => {
      console.log("🔴 WebSocket Closed");
      socketRef.current = null;
    };
  };

  /* 🔌 START SOCKET WHEN CHAT OPENS */
  useEffect(() => {
    if (view === "chatHistory") {
      connectWebSocket();
    }
  }, [view]);

  /* 🧹 CLEANUP */
  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, []);

  /* ---------------- SEND MESSAGE ---------------- */
  const SendText = async () => {
    if (!newMessage.trim()) return;

    await fetch(`https://blogapi.bumppy.com/api/Support/sendSupportChatUser`, {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: UserClient,
        message: newMessage,
      }),
    });

   

    setNewMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    SendText();
  };

  const handleNewChat = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const mobile = formData.get("phone");

    setUserClient(mobile);
    setView("chatHistory");

    await fetch(
      `https://blogapi.bumppy.com/api/Support/submitChatUserDetails`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.get("name"),
          userEmail: formData.get("email"),
          userMobile: mobile,
        }),
      }
    );
  };

  const handleVerification = (e) => {
    e.preventDefault();
    const mobile = new FormData(e.target).get("verification");
    setUserClient(mobile);
    setView("chatHistory");
  };

  return (
    <div className="chat-wrapper">
      {!isOpen && (
        <button className="chat-fab" onClick={() => setIsOpen(true)}>
          <img src={AnlookOwl} alt="chat" />
        </button>
      )}

      {isOpen && (
        <div className="chat-box">
          {/* HEADER */}
          <div className="chat-header">
            <div>
              <h1>
                Hello <span>👋</span>
              </h1>
              <h2>Welcome to SeoBix</h2>
              <p>Need help with Seobix ?</p>
            </div>
            <div className="chat-header-actions">
              {/* {view === "chatHistory" && (
                <FontAwesomeIcon
                  icon={faRotate}
                  onClick={() => setMessages([])}
                />
              )} */}
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>

          {/* BODY */}
          <div className="chat-body">
            {view === "list" && (
              <>
                <Card
                  className="pt-3 pb-3 mb-3"
                  style={{
                    border: "none",
                    borderRadius: "1rem",
                    boxShadow: "0 6px 14px rgba(0,0,0,.08)",
                  }}
                >
                  <div className="d-flex justify-content-center ">
                    <img
                      src={AnlookBanner}
                      alt="support"
                      style={{ width: "50%" }}
                    />
                  </div>
                </Card>

                <div
                  className="chat-card"
                  onClick={() => setView("verifyUser")}
                >
                  <div className="icon user" />
                  <div>
                    <h4>Continue Conversation</h4>
                    <span>View your chat history</span>
                  </div>
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>

                <div className="chat-card" onClick={() => setView("newChat")}>
                  <div className="icon chat" />
                  <div>
                    <h4>Start New Chat</h4>
                    <span>Get help from our team</span>
                  </div>
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>

                <div className="chat-footer-text">— Welcome to Bix Support</div>
              </>
            )}

            {view === "verifyUser" && (
              <form onSubmit={handleVerification} className="chat-form">
                <div
                  className="pill-switch"
                  style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px 0",
                      borderRadius: "5px",
                      border:
                        verificationMethod === "email"
                          ? "1px solid #4caf50"
                          : "1px solid #ccc",
                      backgroundColor:
                        verificationMethod === "email" ? "#4caf50" : "#f5f5f5",
                      color: verificationMethod === "email" ? "#fff" : "#333",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setVerificationMethod("email")}
                  >
                    Email
                  </button>

                  <button
                    type="button"
                    style={{
                      flex: 1,
                      padding: "10px 0",
                      borderRadius: "5px",
                      border:
                        verificationMethod === "mobile"
                          ? "1px solid #4caf50"
                          : "1px solid #ccc",
                      backgroundColor:
                        verificationMethod === "mobile" ? "#4caf50" : "#f5f5f5",
                      color: verificationMethod === "mobile" ? "#fff" : "#333",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setVerificationMethod("mobile")}
                  >
                    Mobile
                  </button>
                </div>

                <label>
                  Enter your{" "}
                  {verificationMethod === "email" ? "Email" : "Mobile Number"}
                </label>

                <input
                  name="verification"
                  required
                  placeholder={
                    verificationMethod === "email"
                      ? "your@email.com"
                      : "1234567890"
                  }
                />

                <button className="primary-btn">Continue Chat</button>
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "newChat" && (
              <form onSubmit={handleNewChat} className="chat-form">
                <label>Name</label>
                <input name="name" required placeholder="Jhonny Bravo" />

                <label>Email</label>
                <input name="email" required placeholder="email@example.com" />

                <label>Phone</label>
                <input name="phone" required placeholder="911xxxxxx" />

                <button className="primary-btn">Start Chat</button>
                <button
                  type="button"
                  className="secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "chatHistory" && (
              <div className="messages">
                {messages.map((m) => (
                  <div
                    key={m.id}
                    className={`bubble ${
                      m.type === "SENT" ? "sent" : "received"
                    }`}
                    style={{ position: "relative" }}
                  >
                    <div>{m.message}</div>
                    <div
                      style={{
                        fontSize: "10px",
                        color: "#888",
                        marginTop: "4px",
                        textAlign: m.type === "SENT" ? "right" : "left",
                      }}
                    >
                      {m.datetime} 
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
            )}
          </div>

          {/* INPUT */}
          {view === "chatHistory" && (
            <form onSubmit={handleSubmit} className="chat-input">
              <input
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type your message..."
              />
              <button>
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
